import React, { useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Collapse, IconButton, Stack, Typography } from '@mui/material';

type SearchCategorySectionProps = {
  title: string;
  count: number;
  children: React.ReactNode;
};

export default function SearchCategorySection({ title, count, children }: SearchCategorySectionProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Box>
      <Stack
        direction="row"
        alignItems="center"
        spacing={0.5}
        onClick={() => setIsExpanded((expanded) => !expanded)}
        sx={{ cursor: 'pointer', userSelect: 'none', mb: isExpanded ? 1 : 0 }}
      >
        <Typography variant="h6" component="h3">
          {title} ({count})
        </Typography>
        <IconButton
          size="small"
          aria-label={isExpanded ? `Collapse ${title}` : `Expand ${title}`}
          aria-expanded={isExpanded}
          onClick={(event) => {
            event.stopPropagation();
            setIsExpanded((expanded) => !expanded);
          }}
          sx={{
            transform: isExpanded ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.15s',
          }}
        >
          <ExpandMoreIcon />
        </IconButton>
      </Stack>
      <Collapse in={isExpanded} unmountOnExit>
        {children}
      </Collapse>
    </Box>
  );
}
